import MyTabs from '../../components/MyTabs';
import Country from './Country';

const GeneralCountries = () => {

    const tabs = [
        { id: "Basic", title: "Basic Country Info", Component: Country },
    ];

    return (
        <MyTabs list={tabs} />
    )
};

export default GeneralCountries;